module.exports = new __parcel__URL__("report-sprint.2fdeee2a.svg").toString();